'use client';

import { useState, useEffect } from 'react';
import logoDark from '~/assets/images/logo-white.png';
import logoLight from '~/assets/images/logo-black.png';
import Image from 'next/image';
import { useAppRouter } from '~/hooks';

export function Footer() {
  const router = useAppRouter();

  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    // Check for dark mode
    const checkDarkMode = () => {
      const isDark = document.documentElement.classList.contains('dark');
      setIsDarkMode(isDark);
    };

    // Initial check
    checkDarkMode();

    // Create a MutationObserver to watch for class changes on html element
    const observer = new MutationObserver(checkDarkMode);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    });

    return () => observer.disconnect();
  }, []);

  return (
    <footer className="px-4 py-12 bg-background-tertiary text-foreground-secondary border-t border-card-border">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Image
                src={isDarkMode ? logoDark : logoLight}
                alt="Leadbunker"
                className="h-8 w-auto"
                width={200}
                height={100}
              />
            </div>
            <p className="text-foreground-muted">
              The most efficient way to extract contact information from any
              source.
            </p>
          </div>

          <div>
            <h4 className="text-foreground mb-4">Product</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => router.push('landing')}
                  className="hover:text-foreground transition-colors"
                >
                  Features
                </button>
              </li>
              <li>
                <button
                  onClick={() => router.push('pricing')}
                  className="hover:text-foreground transition-colors"
                >
                  Pricing
                </button>
              </li>
              <li>
                <button className="hover:text-foreground transition-colors">
                  API
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-foreground mb-4">Company</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => router.push('about')}
                  className="hover:text-foreground transition-colors"
                >
                  About
                </button>
              </li>
              <li>
                <button className="hover:text-foreground transition-colors">
                  Blog
                </button>
              </li>
              <li>
                <button
                  onClick={() => router.push('contact')}
                  className="hover:text-foreground transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-foreground mb-4">Legal</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => router.push('privacy')}
                  className="hover:text-foreground transition-colors"
                >
                  Privacy Policy
                </button>
              </li>
              <li>
                <button
                  onClick={() => router.push('terms')}
                  className="hover:text-foreground transition-colors"
                >
                  Terms of Service
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-card-border text-center text-foreground-muted">
          <p>&copy; 2025 Leadbunker. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
